import { TweenMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal, getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('');
const ZA_IMG = {
    B1: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711698484739/r2p_b1_768_za.png',
    B2: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711698461581/r2p_b2_768_za.png',
};
export default function B() {
    const { useEffect, useLang, useRouter } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['au', 'cn', 'uk', 'de', 'fr', 'es', 'it', 'eu', 'ph']);
    const imgLocalB6 = getImageLocal(locale, ['cn', 'de', 'es', 'fr', 'it', 'jp', 'kr', 'nl', 'cis']);

    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 750;
        new ScrollMagic.Scene({
            triggerElement: '.river2_details_B',
            triggerHook: 1,
            offset: 0.2 * layoutH,
            duration: 0.5 * layoutH,
        })
            .setTween(TweenMax.to('.river2_details_B .innerBox', 0.5, { opacity: 1 }))
            .addTo(AniContainer);
    }, []);

    return (
        <div className={`river2_details_B ${css.B_2}`}>
            <div className={`innerBox`}>
                <div className="level1">
                    <div className="left item">
                        <EFPic
                            name={['/media/river2/h5/B1.webp', '/media/river2/h5/B1.png']}
                            className="fullImgs"
                            alt={t.rich('river2.details.sec2_msg1')}
                            aria-label={t.rich('river2.details.sec2_msg1')}
                        />
                        {['jp', 'cn', 'tw'].includes(locale) ? (
                            <div className="text msg1">
                                {t.rich('river2.details.sec2_msg1', {
                                    line1: (child: any) => <div className="jp-p2">{child}</div>,
                                    line2: (child: any) => <div className="jp-p1">{child}</div>,
                                })}
                            </div>
                        ) : (
                            <div className="text msg1">
                                {t.rich('river2.details.sec2_msg1', {
                                    p1: (child: any) => <span className="p1">{child}</span>,
                                    p2: (child: any) => <span className="p2">{child}</span>,
                                    p3: (child: any) => <span className="p3">{child}</span>,
                                    p4: (child: any) => <span className="p4">{child}</span>,
                                })}
                            </div>
                        )}
                    </div>
                    <div className="right item">
                        <EFPic
                            name={['/media/river2/h5/B2.webp', '/media/river2/h5/B2.png']}
                            className="fullImgs"
                            alt={t.rich('river2.details.sec2_msg4')}
                            aria-label={t.rich('river2.details.sec2_msg4')}
                        />
                        <div className="text msg2">
                            {t.rich('river2.details.sec2_msg4', {
                                p1: (child: any) => <span className="p1">{child}</span>,
                            })}
                        </div>
                    </div>
                </div>
                <div className="level2">
                    <div className="left item">
                        <EFPic
                            name={['/media/river2/h5/B3.webp', '/media/river2/h5/B3.png']}
                            className="fullImgs"
                            alt={t.rich('river2.details.sec2_msg3')}
                            aria-label={t.rich('river2.details.sec2_msg3')}
                        />
                        <div className="text msg1">
                            {t.rich('river2.details.sec2_msg3', {
                                p1: (child: any) => <span className="p1">{child}</span>,
                            })}
                        </div>
                    </div>
                    {!['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale) && (
                        <div className="right item">
                            <EFPic
                                name={locale === 'za' ? ZA_IMG.B1 : [`/media/river2/h5/B4_${imgSpec}.webp`, `/media/river2/h5/B4_${imgSpec}.png`]}
                                className="fullImgs"
                                alt={t.rich('river2.details.sec2_msg7')}
                                aria-label={t.rich('river2.details.sec2_msg7')}
                            />
                            <div className="text msg4">
                                {t.rich('river2.details.sec2_msg7', {
                                    p2: (child: any) => <span className="p2">{child}</span>,
                                })}
                            </div>
                        </div>
                    )}
                </div>
                <div className="level3">
                    <div className="left item">
                        <EFPic
                            name={
                                ['jp'].includes(locale)
                                    ? [`/media/river2/h5/B5_${locale}.webp`, `/media/river2/h5/B5_${locale}.png`]
                                    : ['/media/river2/h5/B5.webp', '/media/river2/h5/B5.png']
                            }
                            className="fullImgs"
                            alt={t('river2.details.sec2_msg2')}
                            aria-label={t('river2.details.sec2_msg2')}
                        />
                    </div>
                    <div className="right item">
                        <EFPic
                            name={[`/media/river2/h5/B6_${imgLocalB6}.webp`, `/media/river2/h5/B6_${imgLocalB6}.png`]}
                            className="fullImgs"
                            alt={t('river2.details.sec2_msg8')}
                            aria-label={t('river2.details.sec2_msg8')}
                        />
                        <div className="text msg6">{t('river2.details.sec2_msg8')}</div>
                    </div>
                </div>
                <div className="level4">
                    <div className="left item">
                        {locale === 'ph' ? (
                            <img
                                src="https://websiteoss.ecoflow.com/upload/image/1752228151661/o2.jpg"
                                className="fullImgs"
                                alt={t.rich('river2.details.sec2_msg5')}
                                aria-label={t.rich('river2.details.sec2_msg5')}
                            />
                        ) : (
                            <EFPic
                                name={['/media/river2/h5/B7.webp', '/media/river2/h5/B7.png']}
                                className="fullImgs"
                                alt={t.rich('river2.details.sec2_msg5')}
                                aria-label={t.rich('river2.details.sec2_msg5')}
                            />
                        )}

                        <div className="text msg7">
                            {t.rich('river2.details.sec2_msg5', {
                                p1: (child: any) => <span className="p1">{child}</span>,
                            })}
                        </div>
                    </div>
                    <div className="right item">
                        {locale === 'ph' ? (
                            <img
                                src="https://websiteoss.ecoflow.com/upload/image/1751079142333/2-m.jpg"
                                className="fullImgs"
                                alt={t.rich('river2.details.sec2_msg6')}
                                aria-label={t.rich('river2.details.sec2_msg6')}
                            />
                        ) : (
                            <EFPic
                                name={locale === 'za' ? ZA_IMG.B2 : [`/media/river2/h5/B8_${imgSpec}.webp`, `/media/river2/h5/B8_${imgSpec}.png`]}
                                className="fullImgs"
                                alt={t.rich('river2.details.sec2_msg6')}
                                aria-label={t.rich('river2.details.sec2_msg6')}
                            />
                        )}

                        <div className="text msg8">
                            {t.rich('river2.details.sec2_msg6', {
                                p1: (child: any) => <span className="p1">{child}</span>,
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
